module.exports = function() {
  return new Worker(__webpack_public_path__ + "eb9f517aa2666ef210b4.worker.js");
};